import React, { useEffect, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useTransition, animated } from 'react-spring';
import { FaArrowCircleUp, FaAngleDoubleLeft, FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import NavbarDetailBlog from '../../../components/navbarDetailBlog.tsx';
import HeaderDetailBlog from '../utils/headerDetailBlog.tsx';
import Footer from '../../../components/footer.tsx';
import { Link } from 'react-router-dom';
import ImageModal from '../utils/imageModal.tsx';


import usePreventZoom from '../../../preventZoom.js';

import Header from '../../../assets/Blog/ACL/ACL_PART6/Detail/HEADER_DETAIL_ACL_PART6.webp';
import Pict1 from "../../../assets/Blog/ACL/ACL_PART6/Detail/1.webp";
import Pict2 from "../../../assets/Blog/ACL/ACL_PART6/Detail/2.webp";
import Pict3 from "../../../assets/Blog/ACL/ACL_PART6/Detail/3.webp";
import Pict4 from "../../../assets/Blog/ACL/ACL_PART6/Detail/4.webp";
import Pict5 from "../../../assets/Blog/ACL/ACL_PART6/Detail/5.webp";
import Pict6 from "../../../assets/Blog/ACL/ACL_PART6/Detail/6.webp";
import Pict7 from "../../../assets/Blog/ACL/ACL_PART6/Detail/7.webp";
import Pict8 from "../../../assets/Blog/ACL/ACL_PART6/Detail/8.webp";

import Gallery1 from "../../../assets/Blog/ACL/ACL_PART6/Detail/9.webp";
import Gallery2 from "../../../assets/Blog/ACL/ACL_PART6/Detail/10.webp";
import Gallery3 from "../../../assets/Blog/ACL/ACL_PART6/Detail/11.webp";
import Gallery4 from "../../../assets/Blog/ACL/ACL_PART6/Detail/12.webp";
import Gallery5 from "../../../assets/Blog/ACL/ACL_PART6/Detail/13.webp";
import Gallery6 from "../../../assets/Blog/ACL/ACL_PART6/Detail/14.webp";
import Gallery7 from "../../../assets/Blog/ACL/ACL_PART6/Detail/15.webp";
import Gallery8 from "../../../assets/Blog/ACL/ACL_PART6/Detail/16.webp";
import Gallery9 from "../../../assets/Blog/ACL/ACL_PART6/Detail/17.webp";
import Gallery10 from "../../../assets/Blog/ACL/ACL_PART6/Detail/18.webp";
import Gallery11 from "../../../assets/Blog/ACL/ACL_PART6/Detail/19.webp";
import Gallery12 from "../../../assets/Blog/ACL/ACL_PART6/Detail/20.webp";
import Gallery13 from "../../../assets/Blog/ACL/ACL_PART6/Detail/21.webp";
import Gallery14 from "../../../assets/Blog/ACL/ACL_PART6/Detail/22.webp";
import Gallery15 from "../../../assets/Blog/ACL/ACL_PART6/Detail/23.webp";
import Gallery16 from "../../../assets/Blog/ACL/ACL_PART6/Detail/24.webp";
import Gallery17 from "../../../assets/Blog/ACL/ACL_PART6/Detail/25.webp";
import Gallery18 from "../../../assets/Blog/ACL/ACL_PART6/Detail/26.webp";
import Gallery19 from "../../../assets/Blog/ACL/ACL_PART6/Detail/27.webp";
import Gallery20 from "../../../assets/Blog/ACL/ACL_PART6/Detail/28.webp";
import Gallery21 from "../../../assets/Blog/ACL/ACL_PART6/Detail/29.webp";
import Gallery22 from "../../../assets/Blog/ACL/ACL_PART6/Detail/30.webp";
import Gallery23 from "../../../assets/Blog/ACL/ACL_PART6/Detail/31.webp";
import Gallery24 from "../../../assets/Blog/ACL/ACL_PART6/Detail/32.webp";
import Gallery25 from "../../../assets/Blog/ACL/ACL_PART6/Detail/33.webp";
import Gallery26 from "../../../assets/Blog/ACL/ACL_PART6/Detail/34.webp";
import Gallery27 from "../../../assets/Blog/ACL/ACL_PART6/Detail/35.webp";

import CommentListExample from '../../../components/comments/commentListExample.tsx';

const ACLPART6: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 900px)').matches);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedAlt, setSelectedAlt] = useState('');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(30);
        setTimeout(() => {
            setProgress(100);
        }, 600);
    }, []);
  
    const openModal = (imageUrl, imageAlt) => {
        setSelectedImage(imageUrl);
        setSelectedAlt(imageAlt);
        setModalVisible(true);
    };
  
    const closeModal = () => {
        setSelectedImage('');
        setSelectedAlt('');
        setModalVisible(false);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 900px)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 350) {
            setShowScrollToTop(true);
        } else {
            setShowScrollToTop(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const arrowTransition = useTransition(showScrollToTop, {
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(100%)' },
        config: { tension: 300, friction: 20 },
      });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: false});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    usePreventZoom();

    return(
        <div className='App'>
            <NavbarDetailBlog/>
            <div className='pt-20 min-w-screen font-condensed text-textGrey'>
                {/* Loading Bar */}
                <LoadingBar color="#8C001f" progress={progress} onLoaderFinished={() => setProgress(0)} />
                <section className='hidden w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'>
                        <script type='text/javascript' id='mapmyvisitors' src='https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff'></script>
                </section>
                <HeaderDetailBlog backgroundImage={Header} title="Exploring the City of Bratislava, Slovakia (Part 6)" date="31" year="July, 2025" backgroundPosition="center center"></HeaderDetailBlog>
                <div className='author-article text-end pr-4 pt-8 pb-4 text-xs'>
                    <p className='font-condensed text-textGrey'>by Mohammad Rifqi Farhansyah | Association for Computational Linguistics 2025</p>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict1, 'Photo of the bus interior that Kak Iwan and I took to Bratislava.')}>
                            <img
                                src={Pict1}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo of the bus interior that Kak Iwan and I took to Bratislava."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo of the bus interior that Kak Iwan and I took to Bratislava.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Inside FlixBus</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-2xl'>Today, Kak Iwan and I decided to visit a city in another country that is even closer than Salzburg from Vienna.</p>
                        <br/>
                        <p className='text-lg'>
                            Right after finishing the lunch agenda with the D&I awardees, Kak Iwan and I immediately rushed to the bus terminal. The night before, we had booked bus tickets via Omio to go to Bratislava, Slovakia. We took a FlixBus, and the travel time from Vienna to Bratislava was around 1.5 hours. A one-way ticket cost 11 euros, or around IDR 220,000. If converted to rupiah, it might sound quite expensive. But Kak Iwan and I firmly believe that the phrase “since we are already here” carries a very strong meaning, LOL. So we departed at 14:00, aiming to arrive around 15:30.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            Before departing, there was actually a pretty funny incident, at least for me, LOL. When we arrived at the bus terminal, there was already a FlixBus parked there, with a sign saying Bratislava, and the departure time also matched ours. Without thinking too much, I just got on the bus, assuming the system was similar to Indonesia. As soon as I entered, the driver looked shocked and started yelling at me. The problem was, he was yelling in German. Even though I took German classes back in high school, I still had no idea what he was saying. All I understood were his hand gestures telling me to get out. So I got off the bus, told Kak Iwan what happened, and we both laughed about it, HEHEHE.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict2, 'A small souvenir booth around the UFO Observation Deck.')}>
                            <img
                                src={Pict2}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A small souvenir booth around the UFO Observation Deck."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A small souvenir booth around the UFO Observation Deck.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | UFO Observation Deck, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            Once we arrived in Bratislava, we got off at a terminal near the UFO Observation Deck. Compared to Vienna, Bratislava felt much more rural in terms of vibes, while Vienna feels very urban and city-like. We took some photos at the UFO Observation Deck and then walked around the nearby area. There was a souvenir shop selling keychains, postcards, and other typical souvenirs. I messaged my mom asking if she wanted anything, even though it was not from Vienna but from Bratislava. She replied, just buy it, more variety is better. So I ended up buying a few souvenirs there.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        FOUFO – Orang Madura
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Header})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict3, 'View of buildings in Bratislava Old Town.')}>
                            <img
                                src={Pict3}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="View of buildings in Bratislava Old Town."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>View of buildings in Bratislava Old Town.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Bratislava Old Town, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After buying souvenirs, we moved to another nearby area and eventually arrived at Bratislava Old Town. The buildings were very iconic and strongly reflected European culture. It started drizzling, so we decided to take shelter for a bit. While waiting, we saw several groups of tourists being guided by tour guides. Kak Iwan and I looked at each other at the same time, as if sharing the same thought. Instead of being confused on our own, why not just join one of the groups? But then we realized it was a group of elderly tourists. We did not see a single young person among them. So that idea stayed only in our heads and disappeared instantly, LOL.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict4, 'A selfie around the church area.')}>
                            <img
                                src={Pict4}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A selfie around the church area."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A selfie around the church area.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Bratislava, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After the rain stopped and a bit of sunlight appeared, we continued our walk. While walking, we noticed people entering and exiting a building repeatedly. We got curious about what the building was. So we decided to go in, even though we had no idea what it actually was. When the door opened, I immediately realized it was a church, and we are both Muslims. But I thought visiting a church would not suddenly change our faith. So we walked around like other visitors, then left and continued our journey.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict5, 'Photo at Bratislavský hrad, or Bratislava Castle.')}>
                            <img
                                src={Pict5}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo at Bratislavský hrad, or Bratislava Castle."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo at Bratislavský hrad, or Bratislava Castle.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Bratislavský hrad, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            We then checked Google Maps to see what attractions were nearby and found Bratislavský hrad, or Bratislava Castle. We thought it would be interesting, so we headed there. Turns out, reaching the castle required walking uphill, almost like hiking. The path itself was quite comfortable, unlike dirt trails on real mountains. The problem was, Kak Iwan and I forgot to bring our water bottles, LOL. Even though in Europe you can freely refill drinking water from public fountains, we still did not have bottles. Thirst started to hit us hard, especially since the weather was getting warmer, and the top of the hill was still not in sight. Suddenly, we found a drinking water tap. Desperately, we drank water using our hands shaped like a bowl, LOL. After that, we walked a bit more and found a shop. I decided to buy water, and the cashier asked, “still or not?” I did not really understand, so I chose still. Turns out, still water here meant sparkling water, LOL.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict6, 'Photo at the flower garden of Bratislava Castle.')}>
                            <img
                                src={Pict6}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo at the flower garden of Bratislava Castle."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo at the flower garden of Bratislava Castle.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Bratislava Castle, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After drinking and walking a bit more, we finally arrived at Bratislava Castle. The building looked like a fortress, similar to ones commonly found in Indonesia. But here, there was a large flower garden with beautiful colors. We took some photos and sat down for a while. That was where Kak Iwan and I shared our stories. 
                        </p>
                        <br/>
                        <p className='text-lg'>
                            Kak Iwan is a master’s student at Monash University Indonesia under Prof. Derry, while I am a research assistant at Monash University Indonesia and also an assistant to Prof. Derry. Kak Iwan is originally from Boyolali and currently works at one of the ministries. He did his undergraduate studies at PKN STAN. We also realized we have something in common. Both of us come from simple families but share the same determination to build a bright future. After talking for a while, we decided to continue our journey, because there was still one more spot we wanted to visit, and it was quite far, around 30 minutes from where we were.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Not everything that counts… (you know the rest) – Albert Einstein
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Pict3})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict7, 'Photo at the Slovak Radio Building.')}>
                            <img
                                src={Pict7}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo at the Slovak Radio Building."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo at the Slovak Radio Building.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Slovak Radio Building, Slovakia</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After walking for some time, we finally reached the main reason why we came to Bratislava. A building shaped like an inverted pyramid, known as the Slovak Radio Building. What makes it interesting is that it looks very similar to a building in Indonesia, specifically in Bekasi. That building is the iconic inverted pyramid at Summarecon Mall Bekasi, which often becomes the subject of jokes. This place was first recommended to us by Mussa, but unfortunately, he could not join us.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            We walked around a bit more and came across STU, Slovenská technická univerzita, a technical university in Bratislava. I thought to myself, maybe this is like Slovakia’s version of ITB, LOL. We also took a short break at a city park, similar to an alun-alun. In the middle, there was a fountain with small waterfalls, where kids were playing like at a water park. Around it, some adults were dancing together near the fountain. At that moment, I felt extremely relaxed, while imagining that maybe one day I could live here.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict8, 'Photo inside the bus on the way back.')}>
                            <img
                                src={Pict8}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo inside the bus on the way back."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo inside the bus on the way back.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Inside the Bus</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            As the sun started to set and we needed to return to Vienna, we rushed back to the bus terminal we had booked. We got confused several times because the map pointed to a location where we only saw a mall. Turns out, the bus terminal was inside the mall, LOL. Good thing we decided to go in. When we checked our ticket details against the bus schedule screens, we could not find our bus, even though departure time was only 10 minutes away. We asked the staff, and they said the bus had not arrived yet. When there were only 5 minutes left, we still only saw one bus that had been parked there for a while. We asked the driver where it was heading, and he said Brussels, Belgium. So we thought it was not ours.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            Then suddenly, with only 1 minute left before departure, Kak Iwan ran toward me. He had checked the ticket email again and realized that our bus code was the same as the bus heading to Brussels. Turns out, the bus was indeed going to Brussels, but it would pass through Vienna, and we were supposed to get off there. Thank God Kak Iwan rechecked the email. Otherwise, we might have ended up staying overnight in Bratislava, or more precisely, sleeping at the bus terminal.
                        </p>
                        <div className='article-break-1 flex justify-start items-center flex-col'>
                            <hr className='w-full mt-4 mb-4  border-t border-b border-solid'/>
                        </div>
                        <p className='text-lg font-bold'><i>to be continued...</i></p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-8 mb-4'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        DAG DIG DUG, one minute left before departure…
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery1, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 1).")}>
                        <img
                            src={Gallery1}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 1)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 1).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery2, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 2).")}>
                        <img
                            src={Gallery2}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 2)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 2).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery3, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 3).")}>
                        <img
                            src={Gallery3}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 3)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 3).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery4, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 4).")}>
                        <img
                            src={Gallery4}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 4)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 4).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery5, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 5).")}>
                        <img
                            src={Gallery5}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 5)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 5).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery6, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 6).")}>
                        <img
                            src={Gallery6}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 6)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 6).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery7, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 7).")}>
                        <img
                            src={Gallery7}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 7)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 7).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery8, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 8).")}>
                        <img
                            src={Gallery8}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 8)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 8).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery9, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 9).")}>
                        <img
                            src={Gallery9}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 9)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 9).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery10, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 10).")}>
                        <img
                            src={Gallery10}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 10)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 10).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery11, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 11).")}>
                        <img
                            src={Gallery11}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 11)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 11).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery12, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 12).")}>
                        <img
                            src={Gallery12}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 12)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 12).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery13, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 13).")}>
                        <img
                            src={Gallery13}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 13)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 13).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery14, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 14).")}>
                        <img
                            src={Gallery14}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 14)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 14).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery15, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 15).")}>
                        <img
                            src={Gallery15}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 15)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 15).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery16, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 16).")}>
                        <img
                            src={Gallery16}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 16)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 16).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery17, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 17).")}>
                        <img
                            src={Gallery17}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 17)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 17).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery18, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 18).")}>
                        <img
                            src={Gallery18}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 18)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 18).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery19, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 19).")}>
                        <img
                            src={Gallery19}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 19)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 19).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery20, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 20).")}>
                        <img
                            src={Gallery20}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 20)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 20).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery21, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 21).")}>
                        <img
                            src={Gallery21}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 21)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 21).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery22, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 22).")}>
                        <img
                            src={Gallery22}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 22)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 22).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery23, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 23).")}>
                        <img
                            src={Gallery23}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 23)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 23).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery24, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 24).")}>
                        <img
                            src={Gallery24}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 24)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 24).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery25, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 25).")}>
                        <img
                            src={Gallery25}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 25)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 25).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery26, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 26).")}>
                        <img
                            src={Gallery26}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 26)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 26).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery27, "Photo Recap: A small glimpse of the landscape of Bratislava (Part 27).")}>
                        <img
                            src={Gallery27}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: A small glimpse of the landscape of Bratislava (Part 27)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: A small glimpse of the landscape of Bratislava (Part 27).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center px-12 md:mb-8 mb-4 gap-x-8'>
                <Link to="/acl/acl-part5" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    <FaAngleDoubleLeft className='w-3 h-3 text-textRed inline-block mr-1' />
                    PREV 
                </Link>
                <Link to="/acl/acl-part7" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    NEXT 
                    <FaAngleDoubleRight className='w-3 h-3 text-textRed inline-block ml-1' />
                </Link>
            </div>
            <div className='bg-fixed w-full h-96' style={{ backgroundImage: `url(${Pict4})`, backgroundSize: 'cover',  }}>
            </div>
            <CommentListExample postId={6} seriesId={2}/>
            <ImageModal
                showModal={modalVisible}
                closeModal={closeModal}
                imageUrl={selectedImage}
                imageAlt={selectedAlt}
            />
            <Footer/>
            {arrowTransition((style, item) =>
                item ? (
                <animated.div
                    style={style}
                    className="fixed bottom-5 right-5 cursor-pointer z-10"
                    onClick={scrollToTop}
                >
                    <FaArrowCircleUp
                    size={isMd ? 32 : 24}
                    className="text-[#c0c5ca] hover:scale-110"
                    />
                </animated.div>
                ) : null
            )}
        </div>
    );
};

export default ACLPART6